module.exports = __webpack_public_path__ + "static/fonts/PlusJakartaDisplay-Medium.06c6015c.woff2";